import { Drawer } from 'antd';
import { Button } from 'components/Button';
import FilterInput from 'components/Form/filterInput';
import FilterSelect from "components/Form/filterSelect";
import { useCallback,useEffect,useState } from 'react';


const SalaryFilterDrawer = ({   
    searchPlaceholder,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleDateChange

}) => {
  const [placement] = useState('right');  

const [userOption, setUserOption] = useState([]);


useEffect(()=>{
    let _userList = []
    let _users = _userList.map(item=> {
        return{
            label: item.first_name,
            value: item.user_id
        }
    })    
    setUserOption(_users)   
},[])



const setFilterValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        if(selectedValue?.value){
            return selectedValue
    
        }
    }

    return ""

  }, [filters]);

  const setInputValue = useCallback((key) => {
    if(filters.length){
        let selectedValue = [...filters].find(item=> item.key === key)
        return selectedValue?.value
    }
    return ""

  }, [filters]);
  return (
    <>
      <Drawer
        title="Basic Drawer"
        placement={placement}
        closable={true}
        onClose={handleFilterDrawer}
        open={showFilterDrawer}
        key={placement}>

<div className="col mb-3 d-flex justify-content-between">
          <h3 className="page-title">Filters</h3>
          <i onClick={handleFilterDrawer}  className='la la-close cursor-pointer ' />
        </div>     

        <div className='col-12 mb-3' >
          <FilterSelect isClearable={true} onChange={e=>{handleFilterChange(e, "user")}} optionLabel={"label"} optionValue={'value'} options={userOption}  value={setFilterValue("user")} placeholder={"Select User"}/>
        </div>

        <div className='col-12 mb-3' >
       
          <FilterInput  
             defaultValue={setInputValue("email")} 
              onChange={e=>{handleInputChange(e.target.value, "email", true)}} 
              id="email"
              label={"Email"}
            />

        </div>        

        <div className="col-12">
          <Button label="Search" loading={filterLoading} disabled={filterLoading} onClick={handleApplyFilter}   className="btn btn-primary  w-100"/>     
        </div>

      </Drawer>
    </>
  );
};
export default SalaryFilterDrawer;